import {
    REQUEST_FORM_ERRORS_SUCCESS,
    REQUEST_FORM_ERRORS_LOADING
} from "api/global/form-errors-handler";

const initialState = {
    loading: false,
    errors: {}
};

export default function(state = initialState, action) {
    switch (action.type) {
        case REQUEST_FORM_ERRORS_SUCCESS:
            return {
                ...state,
                errors: action.payload,
                loading: false
            };
        case REQUEST_FORM_ERRORS_LOADING:
            return {
                ...state,
                loading: action.payload,
                errors: {},
            };
        default:
            return state;
    }
}
